import { BaseSearchRequest } from "../common/base-search-request";


export class SmsLogReportRequest extends BaseSearchRequest {
  reportType?: string;
  messageType?: string;
  customerId?: number;
}
